import { render } from "./FeedCard.vue?vue&type=template&id=339ad816"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__